import { UrlMatchResult, UrlSegment } from '@angular/router';
import { CITIES, FEATURES } from './seo-config.data';

export function cityFeatureMatcher(
  segments: UrlSegment[]
): UrlMatchResult | null {
  if (segments.length !== 2) return null;
  const [sCity, sFeat] = segments;
  const feature = FEATURES[sFeat.path];
  if (!CITIES[sCity.path] || !feature || feature.singlePage) return null;

  return {
    consumed: segments,
    posParams: {
      city: sCity,
      feature: sFeat,
    },
  };
}

export function featureOnlyMatcher(
  segments: UrlSegment[]
): UrlMatchResult | null {
  if (segments.length !== 1) return null;
  const [sFeat] = segments;
  if (!FEATURES[sFeat.path]) return null;

  return {
    consumed: segments,
    posParams: {
      feature: sFeat,
    },
  };
}
